svg{height:35rem}
/*# sourceMappingURL=traffic-light.component-AXZRRJRU.css.map */
